module.exports = __webpack_public_path__ + "img/rain.a56a7915.svg";